module.exports = __webpack_public_path__ + "media/images/icons/icons_large/49_peaceofCake-9a9c37fd3125f06da5f0067cc43c1202.png";